import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useParams } from 'react-router';
import axios from 'src/utils/axios';
import {
    Grid,
    Paper,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
} from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import moment from 'moment';
import { makeStyles } from '@material-ui/core';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DetailsOfExchangeReceipt from 'src/components/DetailsOfExchangeReceipt';

const useStyles = makeStyles({
    tableHead: {
        fontWeight: 'bold',
        borderLeft: '1px solid #ddd',
    },
    tableRow: {
        borderLeft: '1px solid #ddd',
    }
});

function ReceiptDetail(props) {
    const history = useHistory();
    const classes = useStyles();

    // const { ReceiptNumber } = useParams();

    const params = useParams();
    const ReceiptNumber = params?.ReceiptNumber || props.ReceiptNumber;

    const [serviceReceiptData, setServiceReceiptData] = React.useState([]);
    const [customerData, setCustomerData] = React.useState([]);
    const [laborCodesData, setLaborCodesData] = React.useState([]);
    const [totalCostOfLaborCodes, setTotalCostOfLaborCodes] = React.useState([]);
    const [totalCostOfMaterialCodes, setTotalCostOfMaterialCodes] = React.useState([]);
    const [materialCodesData, setMaterialCodesData] = React.useState([]);
    const [serviceCodesData, setServiceCodesData] = React.useState([]);

    const KDV = 1.18;

    const [loading, setLoading] = React.useState(true);

    useEffect(() => {
        getServiceReceiptData();
        getReceiptCustomerData();
        getReceiptServicesCodesData();
        getReceiptLaborCodesInformation();
        getReceiptMaterialCodesInformation();
    }, [])

    const handleGoBack = () => {
        const fullPath = location.pathname;
        var basePath = fullPath.substring(0, fullPath.lastIndexOf('/'));
        localStorage.setItem('previousPath', basePath || '/');
        history.goBack();
    };

    const getServiceReceiptData = () => {
        axios.get(`GetServiceReceiptInformation/${ReceiptNumber}`)
            .then((response) => {
                var serviceReceiptData = response.data[0];
                setServiceReceiptData(serviceReceiptData ? serviceReceiptData : []);
                setLoading(false);
            }).catch((error) => {
                setLoading(false);
            });
    }

    const getReceiptCustomerData = () => {
        axios.get(`GetReceiptCustomerData/${ReceiptNumber}`)
            .then((response) => {
                var customerData = response.data[0];
                setCustomerData(customerData ? customerData : []);
                setLoading(false);
            }).catch((error) => {
                setLoading(false);
            });
    }

    const getReceiptServicesCodesData = () => {
        axios.get(`GetReceiptServiceCodesInformation/${ReceiptNumber}`)
            .then((response) => {
                var serviceCodesData = response.data;
                setServiceCodesData(serviceCodesData ? serviceCodesData : []);
            }).catch((error) => {
                setLoading(false);
            });
    }

    const getReceiptLaborCodesInformation = () => {
        axios.get(`GetReceiptLaborCodesInformation/${ReceiptNumber}`)
            .then((response) => {
                var laborCodes = response.data;
                const totalCost = laborCodes.reduce((acc, laborCode) => acc + parseFloat((laborCode.FIYAT.toFixed(2)) * KDV), 0);
                setLaborCodesData(laborCodes);
                setTotalCostOfLaborCodes(totalCost);
            }).catch((error) => {
                setLoading(false);
            });
    }

    const getReceiptMaterialCodesInformation = () => {
        axios.get(`GetReceiptMaterialCodesInformation/${ReceiptNumber}`)
            .then((response) => {
                var materialCodes = response.data;
                let totalCost = materialCodes.reduce((acc, materialCode) => {
                    const malzemefiyat = parseFloat(materialCode.MALZEMEFIYAT.toFixed(2));
                    const miktar = parseFloat(materialCode.MIKTAR);
                    return acc + (malzemefiyat * miktar);
                }, 0);
                setMaterialCodesData(materialCodes);
                setTotalCostOfMaterialCodes(totalCost);
            }).catch((error) => {
                setLoading(false);
            });
    }

    const RouteReceiptStatusHistory = (ReceiptNumber) => {
        history.push(`/ReceiptStatusHistory/${ReceiptNumber}`);
    }

    const RouteReceiptCustomerPage = (PhoneNumber) => {
        history.push(`/ReceiptCustomer/${PhoneNumber}`);
    }

    const RouteReceiptSerialNumberPage = (UYear, UPeriod, ModelCode, SerialNo) => {
        history.push(`/IndividualInquiryReceipts/${UYear}/${UPeriod}/${ModelCode}/${SerialNo}`);
    }

    return (
        <Grid container spacing={1} style={{ overflow: 'auto', maxHeight: '90vh' }}>
            <Grid item xs={1} />
            <Grid item xs={10}>
                <Paper elevation={3} style={{ marginBottom: 20, marginTop: 20 }}>
                    <TableContainer component={Paper}>
                        <Table size='small'>
                            <TableHead>
                                <TableRow style={{ backgroundColor: '#0033a0', color: '#fff' }}>
                                    <TableCell colSpan={8}>
                                        <Grid container alignItems="center">
                                            <Grid item xs={1}>
                                                <IconButton onClick={() => { handleGoBack(); }} style={{ color: '#fff' }}>
                                                    <ArrowBackIcon />
                                                </IconButton>
                                            </Grid>
                                            <Grid item xs={10}>
                                                <Typography variant="h5" align="center" style={{ color: '#fff' }}>
                                                    Servis Hizmet Fişi
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={1} />
                                        </Grid>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {loading ? (
                                    Array.from(new Array(11)).map((_, index) => (
                                        <TableRow key={index}>
                                            {Array.from(new Array(8)).map((_, cellIndex) => (
                                                <TableCell key={cellIndex} colSpan={1}>
                                                    <Skeleton animation="pulse" variant="text" width={150} />
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))
                                ) : (
                                    <>
                                        <TableRow>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Birim:</TableCell>
                                            <TableCell colSpan={3} className={classes.tableRow}>{serviceReceiptData.BIRIM_KODU ? (serviceReceiptData.BIRIM_KODU + '-' + serviceReceiptData.BIRIM_ACIKLAMA) : '-'}</TableCell>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Fiş No:</TableCell>
                                            <TableCell className={classes.tableRow}>{serviceReceiptData.FIS_NO}</TableCell>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Durum:</TableCell>
                                            <TableCell
                                                className={classes.tableRow}
                                            >
                                                {serviceReceiptData.DURUM_ACIKLAMA ? (
                                                    <span
                                                        style={{
                                                            textDecoration: 'underline',
                                                            cursor: 'pointer',
                                                            color: '#4C3BCF'
                                                        }}
                                                        onClick={() => { RouteReceiptStatusHistory(serviceReceiptData.FIS_NO); }}
                                                    >
                                                        {serviceReceiptData.DURUM_ACIKLAMA}
                                                    </span>
                                                ) : (
                                                    '-'
                                                )}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Müşteri:</TableCell>
                                            <TableCell className={classes.tableRow}>{customerData.ADI}</TableCell>
                                            <TableCell colSpan={2} className={classes.tableRow}>{customerData.SOYADI}</TableCell>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Dönem:</TableCell>
                                            <TableCell className={classes.tableRow}>{serviceReceiptData.YIL}/{serviceReceiptData.DONEM}</TableCell>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Malzeme:</TableCell>
                                            <TableCell className={classes.tableRow}>{(serviceReceiptData.MALZEME_TOPLAMI * KDV)?.toFixed(2)}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Adres:</TableCell>
                                            <TableCell colSpan={3} className={classes.tableRow}>{customerData.ADRES}</TableCell>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Başvuru Nedeni:</TableCell>
                                            <TableCell className={classes.tableRow}>{serviceReceiptData.BASVURU_NEDENI}</TableCell>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>İşçilik:</TableCell>
                                            <TableCell className={classes.tableRow}>{(serviceReceiptData.ISCILIK_TOPLAMI * KDV)?.toFixed(2)}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>İlçe:</TableCell>
                                            <TableCell className={classes.tableRow}>{customerData.ILCE}</TableCell>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Şehir:</TableCell>
                                            <TableCell className={classes.tableRow}>{customerData.IL}</TableCell>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Çağrı Tarihi:</TableCell>
                                            <TableCell className={classes.tableRow}>{moment(serviceReceiptData.CAGRI_TARIHI).format('DD/MM/YYYY HH:mm:ss')}</TableCell>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>İndirim:</TableCell>
                                            <TableCell className={classes.tableRow}>{(serviceReceiptData.INDIRIM_TUTARI * KDV)?.toFixed(2)}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Tel1:</TableCell>
                                            <TableCell
                                                className={classes.tableRow}
                                            >
                                                {customerData.TEL1 ? (
                                                    <span
                                                        style={{
                                                            textDecoration: 'underline',
                                                            cursor: 'pointer',
                                                            color: '#4C3BCF'
                                                        }}
                                                        onClick={() => { RouteReceiptCustomerPage(customerData.TEL1); }}
                                                    >
                                                        {customerData.TEL1}
                                                    </span>
                                                ) : (
                                                    '-'
                                                )}
                                            </TableCell>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Tel2:</TableCell>
                                            <TableCell
                                                className={classes.tableRow}
                                            >
                                                {customerData.TEL2 ? (
                                                    <span
                                                        style={{
                                                            textDecoration: 'underline',
                                                            cursor: 'pointer',
                                                            color: '#4C3BCF'
                                                        }}
                                                        onClick={() => { RouteReceiptCustomerPage(customerData.TEL2); }}
                                                    >
                                                        {customerData.TEL2}
                                                    </span>
                                                ) : (
                                                    '-'
                                                )}
                                            </TableCell>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Yan Ödeme:</TableCell>
                                            <TableCell className={classes.tableRow}>{(serviceReceiptData.INDIRIM_TUTARI * KDV)?.toFixed(2)}</TableCell>
                                            <TableCell colSpan={2} className={classes.tableHead}></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Model:</TableCell>
                                            <TableCell className={classes.tableRow}>{serviceReceiptData.KUL_MODEL_KODU}</TableCell>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Model Açıklama:</TableCell>
                                            <TableCell colSpan={3} className={classes.tableRow}>{serviceReceiptData.MODEL_ACIKLAMA}</TableCell>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Net:</TableCell>
                                            <TableCell className={classes.tableRow}>{(serviceReceiptData.NET_TUTAR * KDV)?.toFixed(2)}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Ürün:</TableCell>
                                            <TableCell className={classes.tableRow}>{serviceReceiptData.KUL_MODEL_KODU}</TableCell>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Ürün Açıklama:</TableCell>
                                            <TableCell colSpan={3} className={classes.tableRow}>{serviceReceiptData.MODEL_ACIKLAMA}</TableCell>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Garanti Tipi:</TableCell>
                                            <TableCell className={classes.tableRow}>{serviceReceiptData.GARANTI_ACIKLAMA}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Ay/Yıl:</TableCell>
                                            <TableCell className={classes.tableRow}>{serviceReceiptData.HARF_KODU + '(' + (serviceReceiptData.UYIL + ' / ' + serviceReceiptData.UDONEM + ')')}</TableCell>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Seri No:</TableCell>
                                            <TableCell
                                                className={classes.tableRow}
                                            >
                                                {serviceReceiptData.SERINO && serviceReceiptData.SERINO > 1 ? (
                                                    <span
                                                        style={{
                                                            textDecoration: 'underline',
                                                            cursor: 'pointer',
                                                            color: '#4C3BCF'
                                                        }}
                                                        onClick={() => {
                                                            RouteReceiptSerialNumberPage(serviceReceiptData.UYIL, serviceReceiptData.UDONEM, serviceReceiptData.MODEL_KODU, serviceReceiptData.SERINO);
                                                        }}
                                                    >
                                                        {serviceReceiptData.SERINO}
                                                    </span>
                                                ) : (
                                                    serviceReceiptData.SERINO ? serviceReceiptData.SERINO : '-'
                                                )}
                                            </TableCell>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Marka:</TableCell>
                                            <TableCell className={classes.tableRow}>{serviceReceiptData.MARKA_ACIKLAMA}</TableCell>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Başvuru No:</TableCell>
                                            <TableCell className={classes.tableRow}>{serviceReceiptData.BASVURU_NO}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Red Nedeni:</TableCell>
                                            <TableCell colSpan={3} className={classes.tableRow}>{serviceReceiptData.RED_NEDENI ? serviceReceiptData.RED_NEDENI : '-'}</TableCell>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Nitelik:</TableCell>
                                            <TableCell className={classes.tableRow}>{serviceReceiptData.NITELIK_ACIKLAMA}</TableCell>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Bayi Kodu:</TableCell>
                                            <TableCell className={classes.tableRow}>{serviceReceiptData.BAYI_KODU !== '0' ? (serviceReceiptData.BAYI_KODU + '-' + serviceReceiptData.BAYIADI) : '-'}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>İşlem Tarihi:</TableCell>
                                            <TableCell className={classes.tableRow}>{moment(serviceReceiptData.ISLEM_TARIHI).format('DD/MM/YYYY HH:mm:ss')}</TableCell>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Garanti Tarihi:</TableCell>
                                            <TableCell className={classes.tableRow}>{moment(serviceReceiptData.GARANTI_TARIHI).format('DD/MM/YYYY')}</TableCell>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Muh.Tarihi:</TableCell>
                                            <TableCell className={classes.tableRow}>{moment(serviceReceiptData.MUHASEBELESME_TARIHI).format('DD/MM/YYYY')}</TableCell>
                                            <TableCell colSpan={2} className={classes.tableHead}></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Teknisyen Kodu:</TableCell>
                                            <TableCell className={classes.tableRow}>{serviceReceiptData.KUL_TEK_KODU}</TableCell>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Tek. Adı Soyadı:</TableCell>
                                            <TableCell className={classes.tableRow}>{serviceReceiptData.ADI} {serviceReceiptData.SOYADI}</TableCell>
                                            <TableCell className={classes.tableHead} style={{ fontWeight: 'bold' }}>Ek Garanti Sertifika No:</TableCell>
                                            <TableCell className={classes.tableRow}>{serviceReceiptData.EKGAR_SERTIFIKA_NO}</TableCell>
                                            <TableCell colSpan={2} className={classes.tableHead}></TableCell>
                                        </TableRow>
                                    </>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Grid>
            <Grid item xs={1} />
            <Grid item xs={1} />
            <Grid item xs={10}>
                <Paper elevation={3} style={{ marginBottom: 20 }}>
                    <TableContainer component={Paper}>
                        <Table size='small'>
                            <TableHead>
                                <TableRow style={{ backgroundColor: '#0033a0', color: '#fff' }}>
                                    <TableCell colSpan={8} align="center">
                                        <Typography variant="h5" style={{ color: '#fff' }}>
                                            Başvuru
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {loading ? (
                                    Array.from(new Array(1)).map((_, index) => (
                                        <TableRow key={index}>
                                            {Array.from(new Array(2)).map((_, cellIndex) => (
                                                <TableCell key={cellIndex} colSpan={1}>
                                                    <Skeleton animation="pulse" variant="text" width={300} />
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell className={classes.tableHead} width={100} style={{ fontWeight: 'bold' }}>{'Notlar:'}</TableCell>
                                        <TableCell className={classes.tableRow}>{serviceReceiptData.NOTLAR ? serviceReceiptData.NOTLAR : '-'}</TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Grid>
            <Grid item xs={1} />
            <Grid item xs={1} />
            <Grid item xs={10}>
                <DetailsOfExchangeReceipt ReceiptNumber={ReceiptNumber} />
            </Grid>
            <Grid item xs={1} />
            <Grid item xs={1} />
            <Grid item xs={10}>
                <Paper elevation={3} style={{ marginBottom: 20 }}>
                    <TableContainer component={Paper}>
                        <Table size='small'>
                            <TableHead>
                                <TableRow style={{ backgroundColor: '#0033a0', color: '#fff' }}>
                                    <TableCell colSpan={2} align="center">
                                        <Typography variant="h5" gutterBottom style={{ color: '#fff' }}>
                                            Hizmet
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        align='right'
                                        style={{
                                            border: '1px solid #ddd',
                                            fontSize: '1rem',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Hizmet
                                    </TableCell>
                                    <TableCell
                                        align='left'
                                        style={{
                                            border: '1px solid #ddd',
                                            fontSize: '1rem',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Tanımı
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {loading ? (
                                    Array.from(new Array(3)).map((_, index) => (
                                        <TableRow key={index}>
                                            {Array.from(new Array(2)).map((_, cellIndex) => (
                                                <TableCell key={cellIndex} colSpan={1}>
                                                    <Skeleton animation="pulse" variant="text" width={750} />
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))
                                ) : (
                                    serviceCodesData.length > 0 && serviceCodesData.map((service, index) => (
                                        <TableRow key={index}>
                                            <TableCell width={750} align='right' style={{ borderRight: '1px solid #ddd', }}>{service.KUL_HIZMET_KODU}</TableCell>
                                            <TableCell width={750} align='left'>{service.ACIKLAMA}</TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Grid>
            <Grid item xs={1} />
            <Grid item xs={1} />
            <Grid item xs={10}>
                <Paper elevation={3} style={{ marginBottom: 20 }}>
                    <TableContainer component={Paper}>
                        <Table size='small'>
                            <TableHead>
                                <TableRow style={{ backgroundColor: '#0033a0', color: '#fff' }}>
                                    <TableCell colSpan={3} align="center">
                                        <Typography variant="h5" gutterBottom style={{ color: '#fff' }}>
                                            İşçilik
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        align='right'
                                        style={{
                                            border: '1px solid #ddd',
                                            fontSize: '1rem',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        İşçilik Kodu
                                    </TableCell>
                                    <TableCell
                                        align='left'
                                        style={{
                                            border: '1px solid #ddd',
                                            fontSize: '1rem',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Tanımı
                                    </TableCell>
                                    <TableCell
                                        align='left'
                                        style={{
                                            border: '1px solid #ddd',
                                            fontSize: '1rem',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Fiyat
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {loading ? (
                                    Array.from(new Array(3)).map((_, index) => (
                                        <TableRow key={index}>
                                            {Array.from(new Array(3)).map((_, cellIndex) => (
                                                <TableCell key={cellIndex} colSpan={1}>
                                                    <Skeleton animation="pulse" variant="text" width={750} />
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))
                                ) : (
                                    <>
                                        {laborCodesData.length > 0 && laborCodesData.map((laborCodes, index) => (
                                            <TableRow key={index}>
                                                <TableCell align='right'>{laborCodes.KUL_ISCILIK_KODU}</TableCell>
                                                <TableCell align='left' style={{ border: '1px solid #ddd' }}>{laborCodes.ISCILIK_ACIKLAMA}</TableCell>
                                                <TableCell align='left'>{(laborCodes.FIYAT * KDV).toFixed(2)}</TableCell>
                                            </TableRow>
                                        ))}
                                        <TableRow>
                                            <TableCell colSpan={1}></TableCell>
                                            <TableCell align='right' style={{ fontWeight: 'bold', borderRight: '1px solid #ddd' }}>İşçilik Toplamı:</TableCell>
                                            <TableCell align='left'>{totalCostOfLaborCodes > 0 ? totalCostOfLaborCodes?.toFixed(2) : 0}</TableCell>
                                        </TableRow>
                                    </>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Grid>
            <Grid item xs={1} />
            <Grid item xs={1} />
            <Grid item xs={10}>
                <Paper elevation={3} style={{ marginBottom: 20 }}>
                    <Grid item xs={12}>
                        <TableContainer component={Paper}>
                            <Table size='small'>
                                <TableHead>
                                    <TableRow style={{ backgroundColor: '#0033a0', color: '#fff' }}>
                                        <TableCell colSpan={4} align="center">
                                            <Typography variant="h5" gutterBottom style={{ color: '#fff' }}>
                                                Malzeme
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{ borderRight: '1px solid #ddd' }} align='right'>Malzeme Kodu</TableCell>
                                        <TableCell style={{ borderRight: '1px solid #ddd' }} align='left'>Tanımı</TableCell>
                                        <TableCell style={{ borderRight: '1px solid #ddd' }} align='left'>Miktar</TableCell>
                                        <TableCell style={{ borderRight: '1px solid #ddd' }} align='left'>Fiyat</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {loading ? (
                                        Array.from(new Array(3)).map((_, index) => (
                                            <TableRow key={index}>
                                                {Array.from(new Array(4)).map((_, cellIndex) => (
                                                    <TableCell key={cellIndex} colSpan={1}>
                                                        <Skeleton animation="pulse" variant="text" width={750} />
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        ))
                                    ) : (
                                        <>
                                            {materialCodesData.length > 0 && materialCodesData.map((materialCodes, index) => (
                                                <TableRow key={index}>
                                                    <TableCell style={{ borderRight: '1px solid #ddd' }} align='right'>{materialCodes.MALZEME_STOK_NO}</TableCell>
                                                    <TableCell style={{ borderRight: '1px solid #ddd' }} align='left'>{materialCodes.ACIKLAMA}</TableCell>
                                                    <TableCell style={{ borderRight: '1px solid #ddd' }} align='left'>{materialCodes.MIKTAR}</TableCell>
                                                    <TableCell style={{ borderRight: '1px solid #ddd' }} align='left'>{(materialCodes.MALZEMEFIYAT).toFixed(2)}</TableCell>
                                                </TableRow>
                                            ))}
                                            <TableRow>
                                                <TableCell colSpan={3} align='right' style={{ fontWeight: 'bold', }}>Malzeme Toplamı:</TableCell>
                                                <TableCell align='left' style={{ border: '1px solid #ddd' }}>{totalCostOfMaterialCodes > 0 ? totalCostOfMaterialCodes?.toFixed(2) : 0}</TableCell>
                                            </TableRow>
                                        </>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Paper>
            </Grid>
            <Grid item xs={1} />
        </Grid>
    );
}

export default ReceiptDetail;
